import Module from '@/store/resource/common/module';
import ContactTasks from '@/store/resource/contactTasks';

let module = new Module(new ContactTasks());

export default module.create();
